import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AboutPage } from './pages/AboutPage';
import { AuthPage } from './pages/AuthPage';
import { FaqPage } from './pages/FaqPage';
import { FocoraPrivacyPage } from './pages/FocoraPrivacyPage';
import { FocoraSupportPage } from './pages/FocoraSupportPage';
import { GuideDetailPage } from './pages/GuideDetailPage';
import { GuidesPage } from './pages/GuidesPage';
import { HomePage } from './pages/HomePage';
import { MethodologyPage } from './pages/MethodologyPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ContactPage } from './pages/ContactPage';
import { LegalPage } from './pages/LegalPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PricingPage } from './pages/PricingPage';
import { PlansGuidePage } from './pages/PlansGuidePage';
import { SettingsPage } from './pages/SettingsPage';
import { SitemapPage } from './pages/SitemapPage';
import { ToolPage } from './pages/ToolPage';
import { ToolsPage } from './pages/ToolsPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'tools', element: <ToolsPage /> },
      { path: 'tools/:slug', element: <ToolPage /> },
      { path: 'pricing', element: <PricingPage /> },
      { path: 'checkout', element: <CheckoutPage /> },
      { path: 'plans-and-credits', element: <PlansGuidePage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'dashboard', element: <Navigate to="/settings" replace /> },
      { path: 'guides', element: <GuidesPage /> },
      { path: 'guides/:slug', element: <GuideDetailPage /> },
      { path: 'faq', element: <FaqPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'methodology', element: <MethodologyPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'sitemap', element: <SitemapPage /> },
      { path: 'focora/privacy', element: <FocoraPrivacyPage /> },
      { path: 'focora/support', element: <FocoraSupportPage /> },
      { path: 'privacy', element: <LegalPage /> },
      { path: 'terms', element: <LegalPage /> },
      { path: 'acceptable-use', element: <LegalPage /> },
      { path: 'refund-policy', element: <LegalPage /> },
      { path: 'cookies', element: <LegalPage /> },
      { path: '*', element: <NotFoundPage /> }
    ]
  },
  { path: '/auth', element: <AuthPage /> }
]);

export default function App() {
  return <RouterProvider router={router} />;
}
